/* eslint-disable react-hooks/exhaustive-deps */
import React, {Fragment, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {SELECTOR_IS_AUTH} from '../../redux/selectors/auth';
import {SELECTOR_ADDRESSES, SELECTOR_OTHERS_ADDRESSES} from '../../redux/selectors/addresses';
import {getAddressCitiesIntegrationTerceros, getAddresses} from '../../redux/actions';
import Box from '@material-ui/core/Box';
import AddressDialog from '../../components/AddressDialog';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import {ViewAddressItem} from './viewAddressItem';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import {makeStyles} from '@material-ui/core/styles';
import {setLoadingCheckoutAddress} from '../../redux/actions';
import {SELECTOR_UI_LOADING_CHECKOUT_ADDRESS} from '../../redux/selectors/uiConfig';
import LinearProgress from '@material-ui/core/LinearProgress';
import {List, Table} from 'antd';
import AppButton from '../../components/AppButton';
import {useMediaQuery} from '@material-ui/core';

const useStylesViewAddresses = makeStyles({
  subtitle: {
    fontSize: '1rem',
    fontWeight: 600,
  },
  addedButton: {
    fontWeight: 400,
  },
});

export function ViewAddressList() {
  const loading = useSelector(SELECTOR_UI_LOADING_CHECKOUT_ADDRESS);
  const isAuth = useSelector(SELECTOR_IS_AUTH);
  const addresses = useSelector(SELECTOR_ADDRESSES);
  const othersAddresses = useSelector(SELECTOR_OTHERS_ADDRESSES);

  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState({});

  const classes = useStylesViewAddresses();
  const dispatch = useDispatch();
  const isMobil = useMediaQuery('(max-width:767px)');

  useEffect(() => {
    if (isAuth) {
      dispatch(setLoadingCheckoutAddress(true));
      dispatch(getAddresses())
        .then(() => {
          dispatch(setLoadingCheckoutAddress(false));
        })
        .catch(() => {
          dispatch(setLoadingCheckoutAddress(false));
        });
      dispatch(getAddressCitiesIntegrationTerceros());
    }
  }, [isAuth]);

  return (
    <Box>
      <AddressDialog
        currentEditAddress={{
          city: {},
          state: {},
          active: false,
        }}
        handleClose={() => setOpen(false)}
        open={open}
      />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Box clone mb={2}>
            <Typography className={classes.subtitle} color="textPrimary">
              Dirección
            </Typography>
          </Box>
          <Grid container spacing={2}>
            {loading ? (
              <Grid item xs={12}>
                <LinearProgress />
              </Grid>
            ) : (
              addresses?.map((it) => <ViewAddressItem key={it.id} address={it} />)
            )}
          </Grid>
          <Button color="primary" onClick={() => setOpen(true)} startIcon={<AddIcon />} className={classes.addedButton}>
            Añadir nueva dirección
          </Button>
          {!!othersAddresses.length && (
            <Fragment>
              <Box clone mt={2} mb={2}>
                <Typography className={classes.subtitle} color="textPrimary">
                  Otras direcciones detectadas
                </Typography>
              </Box>
              <Grid container spacing={2}>
                {!isMobil && (
                  <Table
                    columns={[
                      {
                        title: 'Nombre',
                        dataIndex: 'nombres',
                        render: (x) => (
                          <Box fontSize={12} fontWeight={400}>
                            {x}
                          </Box>
                        ),
                      },
                      {
                        title: 'Direccion',
                        dataIndex: 'direccion',
                        render: (x) => (
                          <Box fontSize={12} fontWeight={400}>
                            {x}
                          </Box>
                        ),
                      },
                      {
                        title: 'Ciudad',
                        dataIndex: 'ciudad',
                        render: (x) => (
                          <Box fontSize={12} fontWeight={400}>
                            {x}
                          </Box>
                        ),
                      },
                      {
                        width: 120,
                        render: (address) => {
                          return (
                            <React.Fragment>
                              <AddressDialog
                                currentEditAddress={{
                                  integration_codigo_direccion: address.codigo_direccion,
                                  integration_nit: address.nit_real,
                                  name: address.nombres,
                                  address: address.direccion,
                                  city: {},
                                  state: {},
                                  active: false,
                                }}
                                handleClose={() => {
                                  setOpen2({[`${address.id}`]: false});
                                }}
                                open={open2[`${address.id}`]}
                              />
                              <Grid item xs={12} md={6}>
                                <AppButton
                                  disableElevation
                                  color="primary"
                                  variant="contained"
                                  onClick={() => setOpen2({[`${address.id}`]: true})}
                                >
                                  Seleccionar
                                </AppButton>
                              </Grid>
                            </React.Fragment>
                          );
                        },
                      },
                    ]}
                    dataSource={othersAddresses}
                    pagination={{pageSize: 50}}
                    scroll={{y: 240}}
                  />
                )}
                {isMobil && (
                  <List
                    style={{marginBottom: 20, textAlign: 'center'}}
                    itemLayout="vertical"
                    size="large"
                    pagination={{
                      onChange: (page) => {
                        console.log(page);
                      },
                      pageSize: 10,
                    }}
                    dataSource={othersAddresses}
                    renderItem={(item) => (
                      <>
                        <List.Item
                          key={item.title}
                          style={{
                            width: '100%',
                            padding: 20,
                            marginBottom: 15,
                            textAlign: 'center',
                            boxShadow: '0px 0px 8px #0000001f',
                          }}
                        >
                          <Box fontSize={14} fontWeight={600}>
                            {item.nombres}
                          </Box>
                          <Box fontSize={12} fontWeight={400}>
                            {item.direccion}
                          </Box>
                          <AppButton
                            color="primary"
                            variant="contained"
                            type="primary"
                            onClick={() => setOpen2({[`${item.id}`]: true})}
                          >
                            Selecciona
                          </AppButton>
                        </List.Item>
                        <AddressDialog
                          currentEditAddress={{
                            integration_codigo_direccion: item.codigo_direccion,
                            name: item.nombres,
                            address: item.direccion,
                            city: {},
                            state: {},
                            active: false,
                          }}
                          handleClose={() => {
                            setOpen2({[`${item.id}`]: false});
                          }}
                          open={open2[`${item.id}`]}
                        />
                      </>
                    )}
                  />
                )}
              </Grid>
            </Fragment>
          )}
        </Grid>
      </Grid>
    </Box>
  );
}
